export default __webpack_public_path__ + "media/counselor-1.c5c402c5.png";